export default ({ request }) => ({
  mrpSalesStockInListApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockIn/list',
      method: 'post',
      data,
    })
  },
  mrpSalesStockInDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockIn/detail',
      method: 'post',
      data,
    })
  },
  mrpSalesStockInSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockIn/save',
      method: 'post',
      data,
    })
  },
  mrpSalesStockInDelApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockIn/del',
      method: 'post',
      data,
    })
  },
  mrpSalesStockInSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/sales/stockIn/submit',
      method: 'post',
      data,
    })
  },
})
